import React from 'react'
import { OverlayTrigger, Tooltip, Table } from 'react-bootstrap'

const PowerFans = ({ data }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      這個指標能夠告訴您目前在不同社群下所累積的粉絲數。
    </Tooltip>
  )

  return (
    <>
      <Table striped hover>
        <thead>
          <tr>
            <th scope="col" className="fs-5">
              <h4 className="fw-bolder">
                粉絲總數量
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 50, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <div
                    className="fas fa-question-circle p-1 text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                  ></div>
                </OverlayTrigger>
              </h4>
            </th>
            <th>
              <h4 className="fw-bolder">{data.count_fans}</h4>
            </th>
          </tr>
        </thead>
        <tbody className="table-group-divider">
          <tr>
            <th scope="row">Facebook 按讚數</th>
            <td>{data.count_fb}</td>
          </tr>
          <tr>
            <th scope="row">Instagram 追蹤者</th>
            <td>{data.count_ig}</td>
          </tr>
          <tr>
            <th scope="row">YouTube 訂閱者</th>
            <td>{data.count_yt}</td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}

export default PowerFans
